// Czysta logika liczenia nowej "kotwicy" eventu przy przeciąganiu na kalendarzu zadań.
// Wydzielona z task_calendar_controller.js, żeby dało się ją testować bez DOM (bun:test).
// Kotwica to znacznik startu eventu (event_start || deadline) w formacie "YYYY-MM-DDTHH:MM".
// Kod jest generyczny (nie zależy od "task") - do reużycia w innych kalendarzach.

function pad(n) {
  return String(n).padStart(2, "0")
}

// Parsuje "YYYY-MM-DD" lub "YYYY-MM-DDTHH:MM" na komponenty (naive - bez strefy).
function parseNaive(str) {
  const [datePart, timePart] = String(str).split("T")
  const [y, mo, d] = datePart.split("-").map(Number)
  let h = 0
  let mi = 0
  if (timePart) {
    const [hh, mm] = timePart.split(":").map(Number)
    h = hh
    mi = mm
  }
  return { y, mo, d, h, mi }
}

function formatNaive({ y, mo, d, h, mi }) {
  return `${y}-${pad(mo)}-${pad(d)}T${pad(h)}:${pad(mi)}`
}

// Różnica w pełnych dniach między dwiema datami "YYYY-MM-DD" (liczona w UTC, bez DST).
function dayDiff(fromDateStr, toDateStr) {
  const a = parseNaive(fromDateStr)
  const b = parseNaive(toDateStr)
  const ms = Date.UTC(b.y, b.mo - 1, b.d) - Date.UTC(a.y, a.mo - 1, a.d)
  return Math.round(ms / 86400000)
}

// Godzina "HH:MM" z pozycji Y w kolumnie siatki godzinowej (widok tygodniowy).
// Snap do pełnej pół godziny na wspólnej wartości minut (godzina i minuty liczone z tej
// samej zaokrąglonej liczby - inaczej ostatni kwadrans godziny zawijał się błędnie do :00).
// Clamp do zakresu 00:00..23:30 (start zadania nie może wypaść na 24:00).
export function timeFromY(clickY, rectHeight) {
  const raw = (clickY / rectHeight) * 24 * 60
  let snapped = Math.round(raw / 30) * 30
  snapped = Math.min(Math.max(snapped, 0), 23 * 60 + 30)
  const hour = Math.floor(snapped / 60)
  const minutes = snapped % 60
  return `${pad(hour)}:${pad(minutes)}`
}

// Jak timeFromY, ale zachowuje końcówkę minutową przeciąganego zadania: snapujemy PRZESUNIĘCIE
// do pół godziny, nie wartość bezwzględną. Zadanie o 10:07 przeciągnięte w okolicę 14:00 dostaje
// 14:07, a nie 14:00 - ustawione minuty nie znikają przy przesuwaniu.
// Clamp trzyma się kroku 30 min, żeby wynik nie zgubił końcówki na krańcach doby.
export function timeFromYKeepingMinutes(clickY, rectHeight, anchorStr) {
  const raw = (clickY / rectHeight) * 24 * 60
  const a = parseNaive(anchorStr)
  const anchorMinutes = a.h * 60 + a.mi
  let minutes = anchorMinutes + Math.round((raw - anchorMinutes) / 30) * 30
  while (minutes < 0) minutes += 30
  while (minutes > 24 * 60 - 1) minutes -= 30
  return `${pad(Math.floor(minutes / 60))}:${pad(minutes % 60)}`
}

// Prostokąt (top/height w px) slotu w siatce godzinowej dla podanej minuty dnia.
// Liczony jak render eventu: nagłówek siatki + obszar 24 h pod nim; wysokość nie schodzi
// poniżej jednego slotu 30 min. `clip` (opcjonalny {top, bottom}) przycina wynik do widocznego
// obszaru kontenera ze scrollem - zwraca null, gdy slot wypada całkiem poza nim.
// Wspólne dla ramki podglądu i dla zamrożonego kafelka, żeby oba trafiały w to samo miejsce.
export function hourlySlotBox(minutes, rectTop, rectHeight, headerPx, eventHeight, clip = null) {
  const usable = Math.max(rectHeight - headerPx, 1)
  const slot = usable / 48
  let top = rectTop + headerPx + (minutes / 1440) * usable
  let height = Math.max(eventHeight || slot, slot)

  if (clip) {
    if (top + height <= clip.top || top >= clip.bottom) return null
    const visibleTop = Math.max(top, clip.top)
    height = Math.min(top + height, clip.bottom) - visibleTop
    top = visibleTop
  }
  return { top, height }
}

// Widok miesięczny: przesuwa kotwicę o (dropDate - sourceDate) dni, zachowując godzinę.
// sourceDate to dzień segmentu, który był przeciągany (dla pasków wielodniowych).
export function shiftAnchorByDays(anchorStr, sourceDateStr, dropDateStr) {
  const delta = dayDiff(sourceDateStr, dropDateStr)
  const a = parseNaive(anchorStr)
  const shifted = new Date(Date.UTC(a.y, a.mo - 1, a.d + delta))
  return formatNaive({
    y: shifted.getUTCFullYear(),
    mo: shifted.getUTCMonth() + 1,
    d: shifted.getUTCDate(),
    h: a.h,
    mi: a.mi,
  })
}
